module.exports = __webpack_public_path__ + "static/media/bkg_2.7dbd2ac0.jpg";